import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=d183b2aa&scoped=true&"
import script from "./SinglePage.vue?vue&type=script&lang=js&"
export * from "./SinglePage.vue?vue&type=script&lang=js&"
import style0 from "./SinglePage.vue?vue&type=style&index=0&id=d183b2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d183b2aa",
  null
  
)

export default component.exports